module.exports = __webpack_public_path__ + "img/img3.1fdfb33d.png";